import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MissionAccountingPage_PennylaneQuote_Fragment = graphql(`
  fragment MissionAccountingPage_PennylaneQuote_Fragment on PennylaneQuote {
    id
    quote_number
    status
    amount
    currency_amount
    currency_amount_before_tax
    currency
    date
    deadline
    external_reference
    created_at
    updated_at
    resolvedLinkedInvoices {
      id
      invoice_number
      status
      amount
      currency_amount
      currency_amount_before_tax
      currency
      date
      deadline
      paid
      remaining_amount_with_tax
      external_reference
      created_at
      updated_at
      resolvedPayments {
        id
        label
        currency
        currency_amount
        status
        created_at
      }
      resolvedMatchedTransactions {
        id
        label
        date
        outstanding_balance
        currency
        created_at
      }
    }
  }
`);

export const MissionAccountingPage_PennylaneAccounting_QueryDocument = graphql(`
  query MissionAccountingPage_PennylaneAccounting_Query($id: Id!) {
    findOneMission(id: $id) {
      accountingInfo {
        pennylaneQuoteBridge {
          _id
          userAccount
          activeId
          inactiveIds
          resolvedQuote {
            id
            ...MissionAccountingPage_PennylaneQuote_Fragment
          }
          resolvedInactiveQuotes {
            id
            ...MissionAccountingPage_PennylaneQuote_Fragment
          }
        }
      }
    }
  }
`);

export type MissionPennylaneAccountingData = ResultOf<
  typeof MissionAccountingPage_PennylaneAccounting_QueryDocument
>['findOneMission'];

export type Quote = ResultOf<
  typeof MissionAccountingPage_PennylaneQuote_Fragment
>;

export type Invoice = NonNullable<Quote['resolvedLinkedInvoices']>[number];

export const useMissionPennylaneAccountingQuery = (id = EMPTY_ID) =>
  useGraphQLQuery(
    MissionAccountingPage_PennylaneAccounting_QueryDocument,
    { id },
    { enabled: !!id },
  );
